var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{ref:"element",staticClass:"d-block"},[_c('div',{staticClass:"d-block fixed__on__top__wrapper"},[_c('div',[_c('div',{staticClass:"d-block",class:{ spacing: !_setup.onFixedTop }},[_c(_setup.AccountAlertUsage)],1)])])])
}
var staticRenderFns = []

export { render, staticRenderFns }